import * as ActionType from '../ActionType';
import * as CampaignAPI from '../../components/campaign/CampaignAPI';
import * as TapSurveyAPI from '../../api/TapSurveyAPI';
import * as QualificationAction from './Qualification';

export const initializeCampaign = (campaignIdentifier) => async (dispatch) => {
  dispatch({ type: ActionType.LOAD_CAMPAIGN_REQUEST });
  try {
    const results = await CampaignAPI.get(campaignIdentifier);
    dispatch({
      type: ActionType.LOAD_CAMPAIGN_SUCCESS,
      payload: { campaign: results.data },
    });
    dispatch(
      getTapSurvey(campaignIdentifier, results.data.providable.identifier)
    );
    const { country_id: countryId, language_id: languageId } = results.data;
    dispatch(QualificationAction.getQualificationTopics(countryId, languageId));
  } catch (e) {
    dispatch({
      type: ActionType.LOAD_CAMPAIGN_FAILURE,
      payload: { error: e.message },
    });
  }
};

export const getTapSurvey =
  (campaignIdentifier, tapSurveyIdentifier) => async (dispatch) => {
    dispatch({ type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_REQUEST });
    try {
      const result = await TapSurveyAPI.get(tapSurveyIdentifier);
      dispatch({
        type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS,
        payload: { tapSurvey: result.data, campaignIdentifier },
      });
    } catch (err) {
      dispatch({
        type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_FAILURE,
        payload: { error: err.message },
      });
    }
  };

export const updateTapSurvey =
  (campaignIdentifier, tapSurvey) => async (dispatch) => {
    dispatch({
      type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS,
      payload: { tapSurvey: tapSurvey, campaignIdentifier },
    });
  };

export const updateCampaign = (campaign) => async (dispatch) => {
  dispatch({ type: ActionType.LOAD_CAMPAIGN_SUCCESS, payload: { campaign } });
};

export const fetchCampaign = (campaignIdentifier) => async (dispatch) => {
  dispatch({ type: ActionType.LOAD_CAMPAIGN_REQUEST });
  try {
    const results = await CampaignAPI.get(campaignIdentifier);
    dispatch({
      type: ActionType.LOAD_CAMPAIGN_SUCCESS,
      payload: { campaign: results.data },
    });
  } catch (e) {
    dispatch({
      type: ActionType.LOAD_CAMPAIGN_FAILURE,
      payload: { error: e.message },
    });
  }
};

export const resetCurrentCampaign = () => (dispatch) =>
  dispatch({ type: ActionType.RESET_CURRENT_CAMPAIGN });
